export default __webpack_public_path__ + "static/media/correctMark.3841b489.svg";